var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"link":"","data-cy":"toolbar-list-item-logout"},on:{"click":_vm.profileAccess}},[_c('v-list-item-title',{attrs:{"data-cy":"toolbar-list-item-logout-title"}},[_c('v-icon',{staticClass:"pr-2",attrs:{"small":"","data-cy":"toolbar-list-item-logout-icon"}},[_vm._v(" mdi-account-cog ")]),_vm._v(" Editar Perfil ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }